<script setup lang="ts">
import type { NuxtError } from "#app";
import Button from "./layers/ui/components/button/Button.vue";
const props = defineProps<{ error: NuxtError }>();
const handleError = () => clearError({ redirect: "/campaigns" });

const isServerError = computed(() => {
  return props.error.statusCode >= 500;
});
</script>

<template>
  <div class="text-sm font-semibold">
    <div class="mt-4">
      <div class="flex flex-col items-center mt-20 lg:mt-64 text-center">
        <div class="text-5xl">{{ error?.statusMessage }}</div>
        <div v-if="isServerError" class="text-sm mt-4">
          There was an error. Please try again later or contact our support.
        </div>

        <div class="text-3xl mt-6">Error: {{ error?.statusCode }}</div>
        <Button class="mt-4" @click="handleError"> Go back </Button>
      </div>
    </div>
    <AppFooter />
  </div>
</template>
